
import Event = createjs.Event;

export class Poker2UserEvent extends Event {
    public static CHANGE_PASSWORD_COMPLETE: string = "changePasswordComplete";
    public static CHANGE_PASSWORD_FAILD: string = "changePasswordFaild";
    public static LOGGIN_FAILD: string = "logginFaild";
    public static CHANGE_USERDATA: string = "changeUserdata";
    public static CHANGE_USER_CURRENCY: string = "changeUserCurrency";
    public static CHANGE_USER_XP: string = "changeUserXP";
    public static CHANGE_USER_LEVEL: string = "changeUserLevel";
    public static CHANGE_USER_LOBBY_CONFIG: string = "changeUserLobbyConfig";
    public static REGISTERED: string = "registrieren";
    public static REGISTER_FAILED: string = "registerFailed";
    public static CHANGE_SHOP_STATE: string = "changeShopState";
    public static GET_PLAYER_AVATAR_DATA: string = "changePlayerAvatar";
    public static CHANGE_INVENTAR: string = "changeInventar";
    public static CHANGE_BOOSTER: string = "changeBooster";

    public static PAYMENTBONUS: string = "paymentbouns";
    public static XPBONUS: string = "xpbonus";

    public static MAILVERIFICATION_COMPLETED: string = "emailverificationCompleted";
    public static MAILVERIFICATION_FAILD: string = "emailverificationFaild";

    public params: any[];

    constructor(type: string, params: any[] = null, bubbles: boolean = false, cancelable: boolean = false) {
        super(type, bubbles, cancelable);

        this.params = params;
    }
}
